import { MASCOT_CERT, MASCOT_WORK } from "@/constants";

type MascotAccentProps = {
  /** 使用するぶたキャラクター（背景透過済み） */
  variant?: "cert" | "work";
  className?: string;
};

/**
 * ページ各所に小さく登場させる、小林建設のぶたキャラクター（装飾用）。
 * 文章やボタンに重ならないよう、各セクションの余白に控えめに配置する。
 */
export default function MascotAccent({ variant = "cert", className = "" }: MascotAccentProps) {
  const src = variant === "work" ? MASCOT_WORK : MASCOT_CERT;
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      className={`pointer-events-none absolute select-none object-contain ${className}`}
    />
  );
}